// Route configuration for the application
// Standardizes route names and paths to avoid conflicts

const ROUTES = {
  FEED: {
    path: '/posts',
    name: 'feed',
    icon: {
      active: {
        light: '/images/feed-active-light.svg',
        dark: '/images/feed-active-dark.svg'
      },
      inactive: '/images/feed-inactive.svg'
    }
  },
  DISCUSSIONS: {
    path: '/discussions',
    name: 'discussions',
    icon: {
      active: {
        light: '/images/discussions-active-light.svg',
        dark: '/images/discussions-active-dark.svg'
      },
      inactive: '/images/discussions-inactive.svg'
    }
  },
  CHATS: {
    path: '/chats',
    name: 'chats',
    icon: {
      active: '/images/ok.png',
      inactive: '/images/message.png'
    }
  },
  PROFILE: {
    path: '/profile',
    name: 'profile',
    icon: {
      active: {
        light: '/images/profile-active-light.svg',
        dark: '/images/profile-active-dark.svg'
      },
      inactive: '/images/profile-inactive.svg'
    }
  }
};

// Helper function to get route by name
const getRouteByName = (name) => {
  return Object.values(ROUTES).find(route => route.name === name) || ROUTES.FEED;
};

// Helper function to get all routes
const getAllRoutes = () => {
  return Object.values(ROUTES);
};

export { ROUTES, getRouteByName, getAllRoutes };